import { notifyError, useNotifications } from 'Logic/Notifications.js'
import format from 'date-fns/format'
import useQueryLocations from './useQueryLocations.js'
import createStatementPdf from './create-statement-pdf.js'
import getPdfMake from 'Logic/pdfmake.js'
import parseISO from 'date-fns/parseISO'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnActionViewStatementPdf(props, data) {
  let [, notify] = useNotifications()
  let queryLocations = useQueryLocations(props)

  return async function onActionViewStatementPdf({
    value,
    originalValue,
    args,
    change,
  }) {
    try {
      let locations = await queryLocations([args.statement.LOCATION_ID])
      let pdf = createStatementPdf({
        statement: {
          ...args.statement,
          ...locations[args.statement.LOCATION_ID],
        },
        pdfMake: await getPdfMake(),
        credit_cards: value.credit_cards,
      })

      pdf.download(
        `statement-${args.statement.PATIENT_HUMAN_ID}-${format(
          parseISO(args.statement.REFERENCE_DATE),
          'MM_dd_yyyy'
        )}`
      )
    } catch (error) {
      console.error(error)
      notify(notifyError('Failed to generate PDF for preview'))
    }
  }
}
